export default __webpack_public_path__ + "locales/sl/Profile.json?hash=ab1576f035a6547166077147489afd43";